<template>
    <li class="c-thumbnail-list__item c-thumbnail-list__item-4">
        <a :href="plusItem.url">
            <div class="c-thumbnail-list__img search_plus_list">
                <img :src="plusItem.thumbnail_path" alt="">
            </div>
            <div class="c-thumbnail-list__text">
                <p class="c-bookname" v-for="(talent, i) in plusItem.talents" :key="i">{{ talent.name }}</p>
                <p class="c-booktitle text-truncate2">{{ $filters.truncate(plusItem.item_title, 21, "...") }}</p>
                <!-- <p class="c-thumbnail-list__price c-black"><span class="u-bold">￥1,320</span>（税込）</p> -->
                <div class="c-thumbnail-list__icon">
                    <div class="c-label-new" v-if="plusItem.is_new == true">New</div>
                    <div class="c-label-limited c-label-pink">{{ plusItem.category}}</div>
                </div>
            </div>
        </a>
    </li>
</template>

<script>
    import routeMixin from '../../mixins/route.js';

    export default {
        props: [
            'route_list',
            'plusItem',
        ],
        mixins: [routeMixin],
    }
</script>

<style lang="scss" scoped>
</style>
